interface StyleConfig {
  key: string;
  title: string;
  description: string;
  additionalProps?: Record<string, any>;
  wrapper?: string;
  wrapperProps?: Record<string, any>;
  gridExist?: boolean;
}

interface StyleLayoutItem {
  gridSize: { xs: number; md?: number };
  components: StyleConfig[];
  wrapper?: string;
  wrapperProps?: Record<string, any>;
}

export const previewScheduleCallAnalyticsStyleLayout: StyleLayoutItem[] = [
  {
    gridSize: { xs: 12, md: 3 },
    components: [
      {
        key: 'schedule_statistics_overview.total_scheduled_meetings',
        title: 'Total Meetings',
        description: '',
        additionalProps: {},
        gridExist: true
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 3 },
    components: [
      {
        key: 'schedule_statistics_overview.scheduled',
        title: 'Upcoming Calls',
        description: '',
        additionalProps: {},
        gridExist: true
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 3 },
    components: [
      {
        key: 'schedule_statistics_overview.ongoing',
        title: 'Ongoing Calls',
        description: '',
        additionalProps: {},
        gridExist: true
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 3 },
    components: [
      {
        key: 'schedule_statistics_overview.completed',
        title: 'Completed Calls',
        description: '',
        additionalProps: {},
        gridExist: true
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 3 },
    components: [
      {
        key: 'schedule_statistics_overview.cancelled',
        title: 'Cancelled Calls',
        description: '',
        additionalProps: {},
        gridExist: true
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 3 },
    components: [
      {
        key: 'schedule_statistics_overview.expired',
        title: 'Expired Calls',
        description: '',
        additionalProps: {},
        gridExist: true
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 3 },
    components: [
      {
        key: 'schedule_statistics_overview.total_meeting_duration',
        title: 'Total Meeting Duration',
        description: '',
        additionalProps: {}
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 3 },
    components: [
      {
        key: 'schedule_statistics_overview.average_meeting_duration',
        title: 'Average Duration',
        description: '',
        additionalProps: {}
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 6 },
    components: [
      {
        key: 'schedule_status_distribution',
        title: 'Schedule Status Distribution',
        description: 'This pie chart displays the distribution of different schedule statuses during the selected time frame.',
        additionalProps: {
          height: 550,
          graphHeight: 400,
        }
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 6 },
    components: [
      {
        key: 'schedule_calls_by_date',
        title: 'Schedule Calls by Date',
        description: 'This chart displays the counts of schedule calls scheduled, held per day during the selected time frame',
        additionalProps: {
          dataKeys: ['scheduled', 'held'],
          height: 550,
          graphHeight: 420,
          xAxisKey: 'date',
          colors: ['#3B82F6', '#10B981'],
          xAxisTitle: 'Date',
          yAxisTitle: 'Number of Calls'
        }
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 6 },
    components: [
      {
        key: 'schedule_call_duration_distribution',
        title: 'Call Duration Distribution',
        description: 'Distribution of call durations in different time ranges',
        additionalProps: {
          dataKeys: ['count'],
          xAxisKey: 'duration',
          colors: ['#F59E0B'],
          height: 450,
          graphHeight: 350,
          xAxisTitle: 'Duration Range',
          yAxisTitle: 'Number of Calls'
        }
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 6 },
    components: [
      {
        key: 'booking_lead_time',
        title: 'Booking Lead Time',
        description: 'Distribution of booking lead times in different time ranges',
        additionalProps: {
          dataKeys: ['count'],
          xAxisKey: 'duration',
          colors: ['#F59E0B'],
          height: 450,
          graphHeight: 350,
          xAxisTitle: 'Duration Range',
          yAxisTitle: 'Number of Calls'
        }
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 6 },
    components: [
      {
        key: 'schedule_call_type_distribution',
        title: 'Schedule Call Types Distribution',
        description: 'Distribution of schedule call types such as video, audio, etc.',
        additionalProps: { 
          height: 550,
          graphHeight: 420
         },
        gridExist: true
      }
    ]
  },
  {
    gridSize: { xs: 6 },
    components: [
      {
        key: 'schedule_calls_heatmap',
        title: 'Schedule Calls',
        description: 'This heatmap indicates the hour of the day and the number of schedule calls during that hour for the selected time frame.',
        additionalProps: {
          height: 550,
          graphHeight: 400,
          colorScale: { low: '#E0E7FF', medium: '#A78BFA', high: '#7C3AED' },
          xAxisLabel: 'Hour',
          yAxisLabel: 'Date'
        },
        gridExist: true
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 6 },
    components: [
      {
        key: 'top_meeting_creators',
        title: 'Top Meeting Creators',
        description: 'This chart displays the top meeting creators based on the number of meetings they have scheduled.',
        additionalProps: {
          height: 550,
          graphHeight: 400,
        }
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 6 },
    components: [
      {
        key: 'bookings_over_time',
        title: 'Bookings Over Time',
        description: 'This chart displays the counts of bookings scheduled, completed, cancelled, etc., per day during the selected time frame',
        additionalProps: {
          dataKeys: ['scheduled', 'completed', 'cancelled', 'expired', 'ongoing', 'total'],
          height: 550,
          graphHeight: 420,
          xAxisKey: 'date',
          colors: ['#3B82F6', '#10B981', '#EF4444', '#6B7280', '#F59E0B', '#8B5CF6'],
          xAxisTitle: 'Date',
          yAxisTitle: 'Number of Calls'
        }
      }
    ]
  },
  {
    gridSize: { xs: 12, md: 6 },
    components: [
      {
        key: 'schedule_punctuality_analysis',
        title: 'Punctuality Analysis',
        description: 'Analysis of call punctuality in different time ranges',
        additionalProps: {
          dataKeys: ['count'],
          xAxisKey: 'name',
          colors: ['#F59E0B'],
          height: 450,
          graphHeight: 350,
          xAxisTitle: 'Duration Range',
          yAxisTitle: 'Number of Calls'
        }
      }
    ]
  },
];